module.exports = __webpack_public_path__ + "img/img99.b761fa60.svg";